import styled from 'styled-components'

import { applyIPadOnlyStyle, getResponsiveFontSizeCSS } from 'helpers/css'
import { isMobileOrIPad } from 'utils/device'

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    position: relative;
    /* justify-content: ${({ noOfParticipants }) =>
        noOfParticipants < 7 ? 'center' : 'space-evenly'}; */
`

export const ParticipantWrapper = styled.div`
    width: 12vw;
    height: 12vw;
    border-radius: 50%;
    margin-top: ${({ noOfParticipants }) =>
        `${noOfParticipants === 0 ? 5 : 10}%`};
    position: relative;
    ${() => {
        const unit = isMobileOrIPad ? 'vh' : 'vw'
        return applyIPadOnlyStyle(
            `width: 16${unit},height: 16${unit}, margin-top: 15%`,
            {
                min: 0,
                max: 1370,
                orientation: 'both',
            }
        )
    }}
    ${() => {
        const unit = isMobileOrIPad ? 'vh' : 'vw'
        return applyIPadOnlyStyle(`width: 21${unit},height: 21${unit}`, {
            min: 0,
            max: 1370,
            orientation: 'landscape',
        })
    }}
`

export const ChecklistCheckWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 2vh;
`

export const Icon = styled.img`
    margin-right: 8px;
`

export const Text = styled.p`
    font-size: ${getResponsiveFontSizeCSS(12, 16)};
    color: ${isMobileOrIPad ? 'white' : 'black'};
`
